// @generated by protoc-gen-grpc-gateway-es v0.3.1 with parameter "target=ts,generate_name_parser=true"
// @generated from file ai/h2o/mlops/deployer/v2/config_service.proto (package ai.h2o.mlops.deployer.v2, syntax proto3)
/* eslint-disable */

import type { KubernetesAffinityShortcut, KubernetesTolerationShortcut, MonitoringConfig, SecurityOptionType } from "./config_pb";
import type { KubernetesResourceRequirements } from "./kubernetes_resource_spec_pb";
import { RPC } from "../../../../../runtime";

/**
 * Request method for GetDefaultSecurityOptionType
 * (-- api-linter: core::0131::request-name-required=disabled
 *     aip.dev/not-precedent: This is a singleton resource as per AIP-134. --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDefaultSecurityOptionTypeRequest
 */
export type GetDefaultSecurityOptionTypeRequest = {
}
;
/**
 * Response method for GetDefaultSecurityOptionType
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetDefaultSecurityOptionTypeResponse
 */
export type GetDefaultSecurityOptionTypeResponse = {
/**
 * Default security option type.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.SecurityOptionType default_security_option_type = 1;
 */
defaultSecurityOptionType?: SecurityOptionType;
}
;
/**
 * Request method for ListSecurityOptionTypes
 * (-- api-linter: core::0132::request-parent-required=disabled
 *     api-linter: core::0158::request-page-token-field=disabled
 *     api-linter: core::0158::request-page-size-field=disabled
 *     aip.dev/not-precedent: We need to do this because return always all options. --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListSecurityOptionTypesRequest
 */
export type ListSecurityOptionTypesRequest = {
}
;
/**
 * (-- api-linter: core::0158::response-next-page-token-field=disabled
 *     aip.dev/not-precedent: We need to do this because return always all options. --)
 * Response method for ListSecurityOptionTypes
 *
 * @generated from message ai.h2o.mlops.deployer.v2.ListSecurityOptionTypesResponse
 */
export type ListSecurityOptionTypesResponse = {
/**
 * List of security option types activated for the environment.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.SecurityOptionType security_option_types = 1;
 */
securityOptionTypes?: SecurityOptionType[];
}
;
/**
 * Request for DiscoverKubernetesConfigShortcuts
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DiscoverKubernetesConfigShortcutsRequest
 */
export type DiscoverKubernetesConfigShortcutsRequest = {
}
;
/**
 * Response for DiscoverKubernetesConfigShortcuts
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DiscoverKubernetesConfigShortcutsResponse
 */
export type DiscoverKubernetesConfigShortcutsResponse = {
/**
 * The supported affinity configuration shortcuts.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.KubernetesAffinityShortcut kubernetes_affinity_shortcuts = 1;
 */
kubernetesAffinityShortcuts?: KubernetesAffinityShortcut[];
/**
 * The supported toleration configuration shortcuts.
 *
 * @generated from field: repeated ai.h2o.mlops.deployer.v2.KubernetesTolerationShortcut kubernetes_toleration_shortcuts = 2;
 */
kubernetesTolerationShortcuts?: KubernetesTolerationShortcut[];
}
;
/**
 * Request for DiscoverDefaultRuntimeKubernetesResourceRequirements
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DiscoverDefaultRuntimeKubernetesResourceRequirementsRequest
 */
export type DiscoverDefaultRuntimeKubernetesResourceRequirementsRequest = {
}
;
/**
 * Response for DiscoverDefaultRuntimeKubernetesResourceRequirements
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DiscoverDefaultRuntimeKubernetesResourceRequirementsResponse
 */
export type DiscoverDefaultRuntimeKubernetesResourceRequirementsResponse = {
/**
 * Default runtime K8s resource requirements.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.KubernetesResourceRequirements default_runtime_kubernetes_resource_requirements = 1;
 */
defaultRuntimeKubernetesResourceRequirements?: KubernetesResourceRequirements;
}
;
/**
 * Request for DiscoverKubernetesDeploymentMaxReplicas
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DiscoverKubernetesDeploymentMaxReplicasRequest
 */
export type DiscoverKubernetesDeploymentMaxReplicasRequest = {
}
;
/**
 * Response for DiscoverKubernetesDeploymentMaxReplicas
 *
 * @generated from message ai.h2o.mlops.deployer.v2.DiscoverKubernetesDeploymentMaxReplicasResponse
 */
export type DiscoverKubernetesDeploymentMaxReplicasResponse = {
/**
 * Maximum number of replicas allowed for deployment.
 * When not set, there is no limit on the number of replicas.
 * When set, the value must be >= 0.
 *
 * @generated from field: optional int32 max_replicas = 1;
 */
maxReplicas?: number;
}
;
/**
 * Request for GetMonitoringConfig
 * (-- api-linter: core::0131::request-name-required=disabled
 *     aip.dev/not-precedent: This is a singleton resource as per AIP-134. --)
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetMonitoringConfigRequest
 */
export type GetMonitoringConfigRequest = {
}
;
/**
 * Response for GetMonitoringConfig
 *
 * @generated from message ai.h2o.mlops.deployer.v2.GetMonitoringConfigResponse
 */
export type GetMonitoringConfigResponse = {
/**
 * Monitoring configuration.
 *
 * @generated from field: ai.h2o.mlops.deployer.v2.MonitoringConfig monitoring_config = 1;
 */
monitoringConfig?: MonitoringConfig;
}
;
/**
 * Get default security option.
 *     api-linter: core::0131::http-uri-name=disabled
 *     api-linter: core::0131::method-signature=disabled
 *     aip.dev/not-precedent: This is a singleton resource as per AIP-134. --)
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ConfigService.GetDefaultSecurityOptionType
 */
export const ConfigService_GetDefaultSecurityOptionType = new RPC<GetDefaultSecurityOptionTypeRequest,GetDefaultSecurityOptionTypeResponse>("GET", "/v2/configuration/securityOptionTypes/default");
/**
 * List the activated security options.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ConfigService.ListSecurityOptionTypes
 */
export const ConfigService_ListSecurityOptionTypes = new RPC<ListSecurityOptionTypesRequest,ListSecurityOptionTypesResponse>("GET", "/v2/configuration/securityOptionTypes");
/**
 * Discovers valid Kubernetes configuration shortcuts.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ConfigService.DiscoverKubernetesConfigShortcuts
 */
export const ConfigService_DiscoverKubernetesConfigShortcuts = new RPC<DiscoverKubernetesConfigShortcutsRequest,DiscoverKubernetesConfigShortcutsResponse>("GET", "/v2/configuration:discoverKubernetesConfigShortcuts");
/**
 * Gets default runtime K8s resource requirements.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ConfigService.DiscoverDefaultRuntimeKubernetesResourceRequirements
 */
export const ConfigService_DiscoverDefaultRuntimeKubernetesResourceRequirements = new RPC<DiscoverDefaultRuntimeKubernetesResourceRequirementsRequest,DiscoverDefaultRuntimeKubernetesResourceRequirementsResponse>("GET", "/v2/configuration:discoverDefaultRuntimeKubernetesResourceRequirements");
/**
 * Discovers the max replicas applicable to Kubernetes deployment.
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ConfigService.DiscoverKubernetesDeploymentMaxReplicas
 */
export const ConfigService_DiscoverKubernetesDeploymentMaxReplicas = new RPC<DiscoverKubernetesDeploymentMaxReplicasRequest,DiscoverKubernetesDeploymentMaxReplicasResponse>("GET", "/v2/configuration:discoverKubernetesDeploymentMaxReplicas");
/**
 * Get monitoring configuration.
 *     api-linter: core::0131::http-uri-name=disabled
 *     api-linter: core::0131::method-signature=disabled
 *     aip.dev/not-precedent: This is a singleton resource as per AIP-134. --)
 *
 * @generated from rpc ai.h2o.mlops.deployer.v2.ConfigService.GetMonitoringConfig
 */
export const ConfigService_GetMonitoringConfig = new RPC<GetMonitoringConfigRequest,GetMonitoringConfigResponse>("GET", "/v2/configuration/monitoring");
